import {ChildrenProps} from '@app/helpers/react';
import {MouseEventHandler, useCallback} from 'react';
import styled from 'styled-components';

interface Props extends ChildrenProps {
  enabled?: boolean;
}

const ContentsContainer = styled.div`
  display: contents;
`;

export const DropdownKeepOpen = ({enabled = true, children}: Props) => {
  const cb: MouseEventHandler<HTMLDivElement> = useCallback(
    (e) => {
      if (enabled) {
        e.stopPropagation();
      }
    },
    [enabled]
  );
  return <ContentsContainer onClick={cb}>{children}</ContentsContainer>;
};
